import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const getPMTProv = (payload: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PMT_PROVIDER_REQUEST });

  return api.authorization.PMTProv.get(payload)
    .then((res: any) => {

      dispatch({
        type: types.GET_PMT_PROVIDER_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PMT_PROVIDER_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const postPainManagement = (payload: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.authPMTProv.isPosting) { return Promise.reject(); }

  dispatch({ type: types.POST_PAIN_MGMT_REQUEST });

  return api.authorization.PMTProv.postPainManagement(payload)
    .then((res: any) => {

      dispatch({
        type: types.POST_PAIN_MGMT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.POST_PAIN_MGMT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const validatePulmNoduleAndPainClinic = (payload: any) => async (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.VALIDATE_PAIN_MGMT_REQUEST });

  try {
    const res = await api.authorization.PMTProv.validatePulmNoduleAndPainClinic(payload);

    dispatch({
      type: types.VALIDATE_PAIN_MGMT_SUCCESS,
      payload: res,
    });

    return res;
  } catch (err: any) {

    const msg = _get(err, 'response.data.msg', 'Post failed!');
    const errors = _get(err, 'response.data.errors', {});
    const payload = { ...err, msg, errors };

    dispatch({
      type: types.VALIDATE_PAIN_MGMT_FAILURE,
      payload,
    });

    return Promise.reject(payload);
  }
};
